import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { getSidebarCustomize } from "@devowl-wp/customize";
import { UpsellTag } from "@devowl-wp/react-cookie-banner-admin";
import { CustomizeContextProvider } from "../components/customize/contextProvider.js";
/**
 * Add an "Unlock" tag to a given customize label id.
 */ function applyCustomizeProTag(controlId, feature) {
    const customize = getSidebarCustomize();
    customize.control(controlId, ()=>{
        const element = document.querySelector(`label[for="_customize-input-${controlId}"]`);
        const span = document.createElement("span");
        element.appendChild(span);
        createRoot(span).render(/*#__PURE__*/ _jsx(CustomizeContextProvider, {
            children: /*#__PURE__*/ _jsx(UpsellTag, {
                ...feature,
                wrapperAttributes: {
                    style: {
                        marginLeft: 5
                    }
                }
            })
        }));
    });
}
export { applyCustomizeProTag };
